// extracted by mini-css-extract-plugin
export default {"row":"SwitchVariantsParametersStyles_row__4-DcO","rowWithTextarea":"SwitchVariantsParametersStyles_rowWithTextarea__8Pj3Z"};